import { render } from "./FilterOnPublicationTypeComponent.vue?vue&type=template&id=40e2d1b9&ts=true"
import script from "./FilterOnPublicationTypeComponent.vue?vue&type=script&lang=ts"
export * from "./FilterOnPublicationTypeComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src186264411/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__